import type {Theme} from "@src/features/settings/settings-models";


const THEME_KEY = "settingsTheme";


function saveTheme(theme: Theme): void {
	localStorage.setItem(THEME_KEY, theme);
}


function loadTheme(defaultTheme: Theme): Theme {
	const storedData = localStorage.getItem(THEME_KEY) as Theme;
	if (storedData) {
		return storedData;
	}
	return defaultTheme;
}


function clearTheme(): void {
	localStorage.removeItem(THEME_KEY);
}


export const themeStorage = {
	saveTheme, loadTheme, clearTheme
} as const;
